import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { BENEFICIARY_DOWNLOAD_MENUS } from '../Layout/menu-names'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getMenuListSelector } from '../../store/selectors/app.selector'

export default function BeneficiaryOption() {
  const history = useHistory()
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['BENEFICIARY_DOWNLOAD_MENUS'] || {}

  return (
    <LayoutWithAccountCard breadCumKey='DOWNLOAD_BENE'>
      <Row>
        {Object.keys(menuConfig).length > 0 &&
          BENEFICIARY_DOWNLOAD_MENUS.map((option, index) => (
            <>
              {menuConfig[option.key] && (
                <Col
                  onClick={() => history.push(option.link)}
                  xs={'auto'}
                  sm={'auto'}
                  md={'auto'}
                  key={index}
                  className='account-menu-card'>
                  <img width={52} height={40} src={option.icon} />
                  <h2>{t(option.title)}</h2>
                  <span>{option.desc}</span>
                </Col>
              )}
            </>
          ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
